import { useState } from "react";
import axios from "./axios";
import { toast } from "sonner";

export const useVerifyCardPayment = () => {
  const [loading, setLoading] = useState(false);
  const verifyCardPayment = async (transId, method) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `/audiences/wallet/fund-wallet/card-funding/${transId}?payment_channel=${method}`
      );

      if (response.status === 200) {
        setLoading(false);
        toast.success("Wallet funded successfully!");
        return true;
      }
      return false;
    } catch (error) {
      setLoading(false);
      toast.error(
        error.response?.data?.message || "Failed to verify card payment"
      );
      return false;
    }
  };

  return { verifyCardPayment, loading };
};
